import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "login",
            component: () => import("@/views/login"),
            meta: {
                title: "登录"
            }
        },
        {
            path: "/portal",
            name: "portal",
            component: () => import("@/views/portal"),
            meta: {
                title: "首页"
            }
        },
        {
            path: "/provincial",
            name: "provincial",
            component: () => import("@/views/provincial"),
            meta: {
                title: "综合分析"
            }
        },
        {
            path: "/spotDisplay",
            name: "spotDisplay",
            component: () => import("@/views/spotDisplay"),
            meta: {
                title: "景区综合分析"
            }
        },
        {
            path: "/touristPortrait",
            name: "touristPortrait",
            component: () => import("@/views/touristPortrait"),
            meta: {
                title: "游客画像"
            }
        },
        {
            path: "/todayTicketAnalysis",
            name: "todayTicketAnalysis",
            component: () => import("@/views/todayTicketAnalysis"),
            meta: {
                title: "今日票务分析"
            }
        },
        {
            path: "/ticketAnalysis",
            name: "ticketAnalysis",
            component: () => import("@/views/ticketAnalysis"),
            meta: {
                title: "票务综合分析"
            }
        },
        {
            path:"/spotTouristPortrait",
            name:"spotTouristPortrait",
            component: () => import("@/views/spotTouristPortrait"),
            meta: {
                title: "景区游客画像"
            }
        },
        {
            path:"/smallProgram",
            name:"smallProgram",
            component: () => import("@/views/smallProgram"),
            meta: {
                title: "小程序使用情况"
            }
        }




    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js